module.exports = __webpack_public_path__ + "static/media/feishu_app.cb0042bf.png";